





















import { mapGetters, mapState } from 'vuex'
import CShareButtons from '~/components/shared/configurable/social/CShareButtons.vue'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import { defineComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  components: { CShareButtons },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    },
    modalToggle: {
      type: Boolean,
      default: false
    },
    modalInSearch: {
      type: Boolean,
      default: false
    },
    imageToShare: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    ...mapState(CLASSIFIED_VIEW_NS, {
      title: state => state.classified.title
    }),
    ...mapGetters(CLASSIFIED_VIEW_NS, {
      shareableDescription: 'getShareableDescription'
    }),
    isVisible: {
      get() {
        return this.show
      },
      set(newVisibility) {
        this.$emit('visibility-changed', newVisibility)
      }
    }
  }
})
